// ── EjaTV Constants ────────────────────────────
export const ROLES = [
  'capo_tecnico','realizzatore',
  'audio_1','audio_2','audio_3','audio_4','audio_5',
  'controllo','slowmo','drone','crane','mixer_video','tecnico_blt',
  'assistente_1','assistente_2','assistente_3',
  'operatore_1','operatore_2','operatore_3','operatore_4','operatore_5',
  'operatore_6','operatore_7','operatore_8','operatore_9','operatore_10',
];
export const RL = {
  capo_tecnico:'Capo Tecnico', realizzatore:'Realizzatore',
  audio_1:'Audio 1', audio_2:'Audio 2', audio_3:'Audio 3', audio_4:'Audio 4', audio_5:'Audio 5',
  controllo:'Controllo', slowmo:'SlowMo', drone:'Drone', crane:'Crane',
  mixer_video:'Mixer Video', tecnico_blt:'Tecnico BLT',
  assistente_1:'Assistente 1', assistente_2:'Assistente 2', assistente_3:'Assistente 3',
  operatore_1:'Op.1',operatore_2:'Op.2',operatore_3:'Op.3',operatore_4:'Op.4',operatore_5:'Op.5',
  operatore_6:'Op.6',operatore_7:'Op.7',operatore_8:'Op.8',operatore_9:'Op.9',operatore_10:'Op.10',
};
export const TIPOLOGIE=['Live','Remote','Live RTS','Live Social','REC','Allestimento','Produzione'];
export const REGIE=['NUOVA','VECCHIA','FLY'];

// Lifecycle: draft → confirmed → in_corso → closed → fatturato → pagato → archived
export const STATUSES=['draft','confirmed','in_corso','closed','fatturato','pagato','archived'];
export const ACTIVE_STATUSES=['draft','confirmed','in_corso','closed'];
export const ARCHIVE_STATUSES=['fatturato','pagato','archived'];
export const SL={
  draft:'Bozza', confirmed:'Confermato', in_corso:'In corso',
  closed:'Chiuso', fatturato:'Fatturato', pagato:'Pagato', archived:'Archiviato'
};

export const INVOICE=['preventivo','confermato','fatturato','pagato','annullato'];
export const MAT_CAT=['camera','audio','regia','kit','illuminazione','altro'];
export const MEZZI_CAT=['auto','furgone','van','carrello','altro_mezzo'];
export const ALL_MAT_CAT=[...MAT_CAT,...MEZZI_CAT];
export const MONTHS=['','Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

export const STATUS_COLORS={
  draft:     {bg:'#F3F4F6',color:'#6B7280',border:'#E5E7EB'},
  confirmed: {bg:'#D1FAE5',color:'#065F46',border:'#6EE7B7'},
  in_corso:  {bg:'#DBEAFE',color:'#1D4ED8',border:'#93C5FD'},
  closed:    {bg:'#F1F5F9',color:'#475569',border:'#CBD5E1'},
  fatturato: {bg:'#E0E7FF',color:'#3730A3',border:'#A5B4FC'},
  pagato:    {bg:'#DCFCE7',color:'#166534',border:'#86EFAC'},
  archived:  {bg:'#F9FAFB',color:'#9CA3AF',border:'#E5E7EB'},
};
export const INV_COLORS={
  preventivo:{bg:'#FEF3C7',color:'#92400E',border:'#FDE68A'},
  confermato:{bg:'#D1FAE5',color:'#065F46',border:'#6EE7B7'},
  fatturato: {bg:'#DBEAFE',color:'#1D4ED8',border:'#93C5FD'},
  pagato:    {bg:'#DCFCE7',color:'#166534',border:'#86EFAC'},
  annullato: {bg:'#FEE2E2',color:'#991B1B',border:'#FCA5A5'},
};
// Pagination defaults
export const PAGE_SIZE = 20;

// Vehicle types
export const VEHICLE_TYPES=['furgone','auto','camion','rimorchio','altro'];
export const VT={furgone:'Furgone',auto:'Auto',camion:'Camion',rimorchio:'Rimorchio',altro:'Altro'};
export const VEHICLE_STATUS={disponibile:'Disponibile',assegnato:'Assegnato',manutenzione:'Manutenzione',fuori_servizio:'Fuori servizio'};
export const VS_COLORS={
  disponibile:{bg:'#D1FAE5',color:'#065F46',border:'#6EE7B7'},
  assegnato:{bg:'#DBEAFE',color:'#1D4ED8',border:'#93C5FD'},
  manutenzione:{bg:'#FEF3C7',color:'#92400E',border:'#FDE68A'},
  fuori_servizio:{bg:'#FEE2E2',color:'#991B1B',border:'#FCA5A5'},
};
